import { Component, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { TypeConceptModel } from 'src/app/models/management/type-concept.model';
import { TypeConceptService } from 'src/app/services/management/type-concept.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-register-type-concept',
  templateUrl: './register-type-concept.component.html',
  styleUrls: ['./register-type-concept.component.scss'],
  standalone: false
})
export class RegisterTypeConceptComponent implements OnInit {
  formTypeConcept: FormGroup = new FormGroup({});
  subscription: Subscription;
  typeConceptContract: TypeConceptModel = new TypeConceptModel;
  typeConceptId: number = 0;

  constructor(public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    @Optional() private ref: DynamicDialogRef,
    private toastHandlerService: ToastHandlerService,
    private typeConceptService: TypeConceptService,) { }

  ngOnInit(): void {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = input$?.subscribe((inputs: any) => {
      this.typeConceptContract = inputs.typeConceptModel;
      if (this.typeConceptContract && this.typeConceptContract.typeConceptId != 0) {
        this.typeConceptId = this.typeConceptContract.typeConceptId;
      }
      this.validateForm(new TypeConceptModel());
      this.handleInitialState();
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  changeTypeConcept() {
    const code = this.formTypeConcept.get("code")?.value;

    if (code != 0) {
      this.getTypeConceptByCode(code);
    } else {
      this.createNewTypeConcept();
    }
  }

  createNewTypeConcept() {
    this.typeConceptId = 0;
    this.typeConceptContract = new TypeConceptModel();
    this.validateForm(this.typeConceptContract);
    setTimeout(() => this.formTypeConcept.controls["code"].disable(), 100);
  }

  async getTypeConceptByCode(code: number) {
    try {
      this.typeConceptContract = await firstValueFrom(this.typeConceptService.getTypeConceptByCode(code));
      this.typeConceptId = this.typeConceptContract.typeConceptId;
      this.validateForm(this.typeConceptContract);
    } catch (error) {
      console.error('Error al buscar el tipo concepto por código.', error);
    }
  }

  async getTypeConceptById() {
    try {
      this.typeConceptContract = await firstValueFrom(this.typeConceptService.getTypeConceptById(this.typeConceptId));
      this.typeConceptId = this.typeConceptContract.typeConceptId;
      await this.validateForm(this.typeConceptContract);
    } catch (error) {
      console.error('Error al buscar tipo concepto por id.', error);
    }
  }

  async handleInitialState() {
    if (this.typeConceptId !== null && this.typeConceptId !== 0) {
      await this.getTypeConceptById();
    } else {
      this.createNewTypeConcept();
    }
  }

  async send() {
    Object.keys(this.formTypeConcept.controls).forEach(key => {
      const control = this.formTypeConcept.get(key);
      if (control && control.invalid) {
        console.warn(`${key} es inválido`, control.errors, 'value:', control.value);
      }
    });

    if (this.formTypeConcept.valid) {
      const modelTypeConcept = this.formTypeConcept.getRawValue();

      if (this.typeConceptId == 0) {
        try {
          const response = await firstValueFrom(this.typeConceptService.createTypeConcept(modelTypeConcept));
          this.toastHandlerService.showToast('success', `El tipo concepto fue creada exitosamente.`);
          this.typeConceptContract = response;
          this.typeConceptId = this.typeConceptContract.typeConceptId;
          await this.validateForm(this.typeConceptContract);
        } catch (error) {
          console.error('Error al crear el tipo concepto.', error);
        }
      } else {
        this.typeConceptContract.name = modelTypeConcept.name;
        try {
          const response = await firstValueFrom(this.typeConceptService.updateTypeConcept(this.typeConceptContract));
          this.toastHandlerService.showToast('success', `El tipo concepto fue modificada exitosamente.`);
          this.typeConceptContract = response;
          await this.validateForm(this.typeConceptContract);
        } catch (error) {
          console.error('Error al actualizar el tipo concepto.', error);
        }
      }
      const output$ = this.config.data?.output$;
      output$?.next({ type: 'reload' });
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      code: {
        required: 'La código es obligatirio.',
        maxlength: 'El campo código permite máximo 3 caracteres.'
      },
      name: {
        required: 'El nombre es obligatorio.',
        maxlength: 'El campo nombre permite máximo 150 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formTypeConcept.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm(typeConcept: TypeConceptModel) {
    this.formTypeConcept = this.formBuilder.group({
      code: [typeConcept.code, [Validators.required,]],
      name: [typeConcept.name, [Validators.required, Validators.maxLength(150)]]
    });
  }


}
